import type { CSSProperties, ReactNode } from "react";

import { styled } from "simplydo/react/styled";

import { reserveScrollPadding } from "utils/scrollPadding";

import { NAV_BAR_HEIGHT, Sticky } from "components/lib/UI";

/** Height of the toolbar on computer, used to offset sticky content below it. */
export const ENTITY_TOOLBAR_HEIGHT = 56;

const ToolbarBar = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  height: ${({ theme }) =>
    theme.sizes.isComputer ? ENTITY_TOOLBAR_HEIGHT : 48}px;
  padding: ${({ theme }) =>
    theme.sizes.isComputer ? "10px 20px" : "8px 12px"};
  background: #ffffff;
  border-bottom: 1px solid #eceef2;
  width: 100%;
  z-index: 90;
`;

const Start = styled.div`
  display: flex;
  flex: none;
  align-items: center;
  white-space: nowrap;
`;

type EntityToolbarProps = {
  /** Fixed content, e.g. status and counts. Keep it narrow enough to leave room on phones. */
  start?: ReactNode;
  /** Controls, as `ToolbarItems`, which move into the ⋯ menu when they don't fit. */
  end?: ReactNode;
  style?: CSSProperties;
  className?: string;
  sticky?: boolean;
  stickyTop?: number;
};

const EntityToolbar = ({
  start,
  end,
  style,
  className,
  sticky = true,
  stickyTop = NAV_BAR_HEIGHT,
}: EntityToolbarProps) => {
  const bar = (
    <ToolbarBar style={style} className={className}>
      <Start>{start}</Start>
      {end}
    </ToolbarBar>
  );

  if (!sticky) return bar;

  return (
    <Sticky
      ref={reserveScrollPadding("top", stickyTop)}
      top={stickyTop}
      style={{ zIndex: (style?.zIndex as number) ?? 90 }}
    >
      {bar}
    </Sticky>
  );
};

export default EntityToolbar;
